import { topicZones } from '@/mocks/guaHome';

export default function TopicZones() {
  return (
    <section id="zones" className="scroll-mt-20 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 md:mb-10">
          <div className="flex items-center gap-3">
            <span className="flex h-8 items-center rounded-full bg-red-600/10 px-3 text-xs font-bold tracking-widest text-red-600">06 · 分区</span>
            <span className="text-xs font-medium tracking-widest text-stone-400 uppercase">Topics</span>
          </div>
          <h2 className="font-serif-sc mt-3 text-2xl font-bold text-stone-900 md:text-3xl">分区题材 · 想补哪块直接进</h2>
          <p className="mt-2 max-w-2xl text-sm text-stone-500">所有往期精选、合集与老帖都按题材分区，选一个你关心的专区，整套内容都在里面等着。</p>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {topicZones.map((z) => (
            <a
              key={z.name}
              href="#timeline"
              className="group relative overflow-hidden rounded-2xl border border-stone-200/80 bg-stone-50 p-5 transition-all hover:-translate-y-1 hover:border-red-200 hover:bg-white"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-xl text-red-600 ring-1 ring-stone-200 transition-colors group-hover:bg-gradient-to-br group-hover:from-red-500 group-hover:to-orange-400 group-hover:text-white">
                  <i className={z.icon} />
                </span>
                <span className="text-xs font-bold text-stone-400">{z.count}</span>
              </div>
              <h3 className="mt-4 text-base font-bold text-stone-900 group-hover:text-red-600">{z.name}</h3>
              <p className="mt-1.5 text-[13px] leading-relaxed text-stone-500">{z.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-stone-400 group-hover:text-red-500">
                进入专区
                <i className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}